/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface QsChecksBenutzerZugriff { 
    ist_aktiv?: boolean;
    ist_qs_admin?: boolean;
    admin_fb_ids?: Array<string>;
    ist_qs_controller?: boolean;
    ist_qs_pruefer?: boolean;
    mandant_id: string;
    modified_on_utc: Date;
}

